import { getCertificate } from '@app/api/prImportFreeSales.api';
import React, { useEffect, useState } from 'react';
interface PDFViewerProps {
  id: any;
  pdfUrl: string | null;
  setCurrentBreadcrumName: React.Dispatch<React.SetStateAction<string>>;
}

const CertificateComponent: React.FC<PDFViewerProps> = ({ id, setCurrentBreadcrumName, pdfUrl }) => {
  //const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  // useEffect(() => {
  //   const fetchCertificate = async () => {
  //     if (!id) return;
  //     try {
  //       const data = await getCertificate(Number(id));
  //       setPdfUrl(data?.doc_url || '');
  //     } catch (error) {
  //       console.error('Failed to load certificate:', error);
  //     }
  //   };

  //   fetchCertificate();
  // }, [id]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {pdfUrl ? (
        <iframe src={pdfUrl} width="100%" height="900px" style={{ border: 'none' }} title="PDF Viewer" />
      ) : (
        <p>Loading certificate...</p>
      )}
    </div>
  );
};

export default CertificateComponent;
